export const HomePageFeatureToggles = {
    contractorsRating: false,
    reviews: false,
    recentlyActiveSpecialists: false,
    loginEmail: true,
    loginFacebook: true,
    loginGoogle: true
};